import doubtRepository from "../../../../infrastructure/repository/impl/doubt/doubt_repository";
import DoubtInterface from "./doubtInterface";
import {Doubt} from "../../../entities/doubt";
import {BusinessException, BusinessRuleException} from "../../../exceptions/exceptions";
import DoubtRules from "./doubtRules";

class DoubtUseCases implements DoubtInterface {
  async create(doubt: Doubt, courseID: number, contentID: number): Promise<number> {
    const errors: BusinessException[] = [];

    const idCourseError = DoubtRules.isNotValidID(courseID);
    if (idCourseError) {
      errors.push(idCourseError);
    }

    const idContentError = DoubtRules.isNotValidID(contentID);
    if (idContentError) {
      errors.push(idContentError);
    }

    const titleError = DoubtRules.checkEmptyTitle(doubt.title);
    if (titleError) {
      errors.push(titleError);
    }

    const descriptionError = DoubtRules.checkEmptyDescription(
      doubt.description
    );
    if (descriptionError) {
      errors.push(descriptionError);
    }

    if (errors.length) {
      throw new BusinessRuleException(errors);
    }

    return await doubtRepository.create(doubt, courseID, contentID);
  }

  async list(courseID: number, contentID: number): Promise<Doubt[]> {
    return await doubtRepository.list(courseID, contentID);
  }


}

export default new DoubtUseCases() as DoubtInterface;
